export interface ISidebarModule {
    drawModule(container: HTMLElement): void;
    addMenuButtons?: () => ISidebarMenuButton[];
    isDrawn: boolean;
    name: string;
}

export interface ISidebarMenuButton {
    title: string;
    iconClass: string;
    onClick: (e: MouseEvent) => void;
}
